<form [id]="formId" [formGroup]="formGroup" (submit)="submit()">
  @let country = formGroup.get('country')!;
  @let category = formGroup.get('category')!;
  @let firstName = formGroup.get('firstName')!;
  @let lastName = formGroup.get('lastName')!;
  @let companyName = formGroup.get('companyName')!;
  @let taxNumber = formGroup.get('taxNumber')!;
  @let vatNumber = formGroup.get('vatNumber')!;
  @let streetName = formGroup.get('streetName')!;
  @let streetNumber = formGroup.get('streetNumber')!;
  @let village = formGroup.get('village')!;
  @let postalCode = formGroup.get('postalCode')!;

  <kendo-formfield>
    <kendo-label [text]="('invoiceData.country.label' | translate) + '*'">
      <kendo-combobox
        size="medium"
        [suggest]="true"
        [filterable]="true"
        (filterChange)="filterCountries($event)"
        [formControlName]="country | controlName"
        [data]="filteredGroupedCountries"
        (valueChange)="categoryOrCountryChanged()"
        textField="name"
        valueField="id">
        <ng-template kendoPrefixTemplate>
          <kendo-svg-icon [icon]="icons.globeIcon"/>
        </ng-template>
      </kendo-combobox>
    </kendo-label>
    @if (country.invalid) {
      <kendo-formerror [textContent]="'invoiceData.country.error' | translate"/>
    }
  </kendo-formfield>
  <app-spacer/>
  <div>
    <kendo-label [text]="('invoiceData.category.label' | translate) + '*'"/>
    <ul class="k-radio-list k-list-horizontal">
      <li class="k-radio-item">
        <kendo-radiobutton
          #individual
          size="large"
          class="k-radio-label"
          [value]="categories.INDIVIDUAL"
          (change)="categoryOrCountryChanged()"
          [formControlName]="category | controlName">
        </kendo-radiobutton>
        <kendo-label
          [for]="individual"
          class="k-radio-label"
          [text]="'invoiceData.category.individual' | translate">
        </kendo-label>
      </li>
      <li class="k-radio-item">
        <kendo-radiobutton
          #business
          size="large"
          class="k-radio-label"
          [value]="categories.BUSINESS"
          (change)="categoryOrCountryChanged()"
          [formControlName]="category | controlName">
        </kendo-radiobutton>
        <kendo-label
          [for]="business"
          class="k-radio-label"
          [text]="'invoiceData.category.business' | translate">
        </kendo-label>
      </li>
    </ul>
    @if (formGroup.invalid && !formGroup.untouched && category.getRawValue() !== categories.INDIVIDUAL && category.getRawValue() !== categories.BUSINESS) {
      <kendo-formerror [textContent]="'invoiceData.category.error' | translate"/>
    }
  </div>

  <app-spacer/>
  <hr>
  <app-spacer/>

  @if (category.getRawValue() === categories.BUSINESS) {
    <kendo-formfield>
      <kendo-label [text]="('invoiceData.company.label' | translate) + '*'">
        <kendo-textbox
          size="medium"
          showErrorIcon="initial"
          [formControlName]="companyName | controlName">
          <ng-template kendoPrefixTemplate>
            <kendo-svg-icon [icon]="icons.graphIcon"/>
          </ng-template>
        </kendo-textbox>
      </kendo-label>
      @if (companyName.invalid) {
        <kendo-formerror [textContent]="'invoiceData.company.error' | translate"/>
      }
    </kendo-formfield>
    <app-spacer/>
  }

  @if (category.getRawValue() === categories.INDIVIDUAL) {
    <div class="row">
      <kendo-formfield>
        <kendo-label [text]="('invoiceData.firstName.label' | translate) + '*'">
          <kendo-textbox
            size="medium"
            showErrorIcon="initial"
            [formControlName]="firstName | controlName">
            <ng-template kendoPrefixTemplate>
              <kendo-svg-icon [icon]="icons.userIcon"/>
            </ng-template>
          </kendo-textbox>
        </kendo-label>
        @if (firstName.invalid) {
          <kendo-formerror [textContent]="'invoiceData.firstName.error' | translate"/>
        }
      </kendo-formfield>
      <kendo-formfield>
        <kendo-label [text]="('invoiceData.lastName.label' | translate) + '*'">
          <kendo-textbox
            size="medium"
            showErrorIcon="initial"
            [formControlName]="lastName | controlName">
            <ng-template kendoPrefixTemplate>
              <kendo-svg-icon [icon]="icons.userIcon"/>
            </ng-template>
          </kendo-textbox>
        </kendo-label>
        @if (lastName.invalid) {
          <kendo-formerror [textContent]="'invoiceData.lastName.error' | translate"/>
        }
      </kendo-formfield>
    </div>
    <app-spacer/>
  }

  @if (country.getRawValue()?.code === 'IT') {
    <kendo-formfield>
      <kendo-label [text]="('invoiceData.taxNumber.label' | translate) + (category.getRawValue() === categories.BUSINESS ? '' : '*')"
          [optional]="category.getRawValue() === categories.BUSINESS">
        <kendo-label-messages [optional]="'optional' | translate | lowercase"/>
        <kendo-textbox
          size="medium"
          showErrorIcon="initial"
          [formControlName]="taxNumber | controlName">
          <ng-template kendoPrefixTemplate>
            <kendo-svg-icon [icon]="icons.jsIcon"/>
          </ng-template>
        </kendo-textbox>
      </kendo-label>
      @if (taxNumber.invalid) {
        @if (taxNumber.errors?.['invalidFormat']) {
          <kendo-formerror [textContent]="'invoiceData.taxNumber.invalid' | translate"/>
        } @else {
          <kendo-formerror [textContent]="'invoiceData.taxNumber.error' | translate"/>
        }
      }
    </kendo-formfield>
    <app-spacer/>
  }
  @if (category.getRawValue() === categories.BUSINESS) {
    <kendo-formfield>
      <kendo-label [text]="('invoiceData.vatNumber.label' | translate) + '*'">
        <kendo-textbox
          size="medium"
          showErrorIcon="initial"
          [formControlName]="vatNumber | controlName">
          <ng-template kendoPrefixTemplate>
            <kendo-svg-icon [icon]="icons.fileReportIcon"/>
          </ng-template>
        </kendo-textbox>
      </kendo-label>
      @if (vatNumber.invalid) {
        <kendo-formerror [textContent]="'invoiceData.vatNumber.error' | translate"/>
      }
    </kendo-formfield>
    <app-spacer/>
  }
  <div class="row-items-right">
    <kendo-formfield>
      <kendo-label [text]="('invoiceData.streetName.label' | translate) + '*'">
        <kendo-textbox
          size="medium"
          showErrorIcon="initial"
          [formControlName]="streetName | controlName">
          <ng-template kendoPrefixTemplate>
            <kendo-svg-icon [icon]="icons.homeIcon"/>
          </ng-template>
        </kendo-textbox>
      </kendo-label>
      @if (streetName.invalid) {
        <kendo-formerror [textContent]="'invoiceData.streetName.error' | translate"/>
      }
    </kendo-formfield>
    <kendo-formfield>
      <kendo-label [text]="('invoiceData.streetNumber.label' | translate) + '*'">
        <kendo-textbox
          size="medium"
          showErrorIcon="initial"
          [formControlName]="streetNumber | controlName">
        </kendo-textbox>
      </kendo-label>
      @if (streetNumber.invalid) {
        <kendo-formerror [textContent]="'invoiceData.streetNumber.error' | translate"/>
      }
    </kendo-formfield>
  </div>
  <app-spacer/>
  <div class="row-items-right">
    <kendo-formfield>
      <kendo-label [text]="('invoiceData.village.label' | translate) + '*'">
        <kendo-textbox
          size="medium"
          showErrorIcon="initial"
          [formControlName]="village | controlName">
          <ng-template kendoPrefixTemplate>
            <kendo-svg-icon [icon]="icons.mapMarkerIcon"/>
          </ng-template>
        </kendo-textbox>
      </kendo-label>
      @if (village.invalid) {
        <kendo-formerror [textContent]="'invoiceData.village.error' | translate"/>
      }
    </kendo-formfield>
    <kendo-formfield>
      <kendo-label [text]="('invoiceData.postalCode.label' | translate) + '*'">
        <kendo-textbox
          size="medium"
          showErrorIcon="initial"
          [formControlName]="postalCode | controlName">
        </kendo-textbox>
      </kendo-label>
      @if (postalCode.invalid) {
        <kendo-formerror [textContent]="'invoiceData.postalCode.error' | translate"/>
      }
    </kendo-formfield>
  </div>

</form>
